/* Lax Rat Supply Co. - the stick pass. Every element with class "player" becomes a stick;
   the ball is passed from stick to stick as the page scrolls, and the play reverses on scroll up. */
(function(){
if(document.querySelectorAll('.player').length<2)return;
const STICK_SRC=(document.documentElement.dataset.stickSrc)||'';
if(!document.getElementById('play')){
  document.body.insertAdjacentHTML('beforeend','<svg id="play" aria-hidden="true"><g id="trails"></g><g id="ball"><circle class="b" r="8"/><path d="M-4 -3 Q0 -6 4 -3" fill="none" stroke="#fff" stroke-width="1.6" opacity=".7" stroke-linecap="round"/></g></svg>');
}
/* ============ Sticks that pass the ball down the page ============
   Sprite is upright, 261x1323 sprite px. Pivot = where the hands would be. */
const SA={w:261,h:1323,px:122,py:900,pocketX:127,pocketY:152};
const players=[...document.querySelectorAll('.player')].map(el=>{
  el.innerHTML=`<svg viewBox="0 0 ${SA.w} ${SA.h}" preserveAspectRatio="none" aria-hidden="true"><g class="stick"><image href="${STICK_SRC}" width="${SA.w}" height="${SA.h}"/></g></svg>`;
  return {el,svg:el.querySelector('svg'),stick:el.querySelector('.stick'),m:el.classList.contains('right')?-1:1};
});
// angles in degrees, positive tips the head toward the middle of the page
const POSE={ready:16,release:78,rest:34};
const SPIN_PX=()=>innerWidth<760?170:240; // scroll distance spent spinning + whipping before the ball leaves the pocket
const setAngle=(p,a)=>p.stick.setAttribute('transform',`rotate(${a.toFixed(2)} ${SA.px} ${SA.py})`);
function pocketPos(p,deg){ // document position of the pocket for a stick at a given angle
  const th=deg*Math.PI/180,dx=(SA.pocketX-SA.px)*p.k,dy=(SA.pocketY-SA.py)*p.k;
  return{x:p.pivot.x+p.m*(dx*Math.cos(th)-dy*Math.sin(th)),y:p.pivot.y+(dx*Math.sin(th)+dy*Math.cos(th))};
}

/* ============ The play (scroll-linked passes) ============ */
const play=document.getElementById('play'), trailsG=document.getElementById('trails'), ball=document.getElementById('ball');
const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;
let segs=[];
const lerp=(a,b,t)=>a+(b-a)*t, clamp=(v,a,b)=>Math.max(a,Math.min(b,v));
const easeOut=t=>1-Math.pow(1-t,3), easeInOut=t=>t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2;
function bez(s,t){const u=1-t;return{
  x:u*u*u*s.p0.x+3*u*u*t*s.c1.x+3*u*t*t*s.c2.x+t*t*t*s.p1.x,
  y:u*u*u*s.p0.y+3*u*u*t*s.c1.y+3*u*t*t*s.c2.y+t*t*t*s.p1.y}}
function splitD(s,t){ // path of the curve from 0..t (de Casteljau)
  const L=(a,b)=>({x:lerp(a.x,b.x,t),y:lerp(a.y,b.y,t)});
  const a=L(s.p0,s.c1),b=L(s.c1,s.c2),c=L(s.c2,s.p1),d=L(a,b),e=L(b,c),f=L(d,e);
  return `M${s.p0.x},${s.p0.y} C${a.x},${a.y} ${d.x},${d.y} ${f.x},${f.y}`}
const fullD=s=>`M${s.p0.x},${s.p0.y} C${s.c1.x},${s.c1.y} ${s.c2.x},${s.c2.y} ${s.p1.x},${s.p1.y}`;

function layout(){
  if(reduce){players.forEach(p=>setAngle(p,POSE.ready));return}
  play.style.height='0px';
  play.style.height=document.documentElement.scrollHeight+'px';
  players.forEach(p=>{
    const r=p.svg.getBoundingClientRect();p.k=r.width/SA.w;
    const lx=p.m===1?SA.px*p.k:r.width-SA.px*p.k;
    p.pivot={x:r.left+scrollX+lx,y:r.top+scrollY+SA.py*p.k};
  });
  segs=[];trailsG.innerHTML='';
  for(let i=0;i<players.length-1;i++){
    const p0=pocketPos(players[i],POSE.release),p1=pocketPos(players[i+1],POSE.ready),dx=p1.x-p0.x,dy=p1.y-p0.y;
    const s={p0,p1,a0:players[i].pivot.y,a1:players[i+1].pivot.y,c1:{x:p0.x+dx*.35,y:p0.y-Math.min(140,Math.abs(dy)*.12)},c2:{x:p1.x-dx*.12,y:p1.y-dy*.5}};
    const ns='http://www.w3.org/2000/svg';
    s.ghost=document.createElementNS(ns,'path');s.ghost.setAttribute('class','ghost');s.ghost.setAttribute('d',fullD(s));
    s.trail=document.createElementNS(ns,'path');s.trail.setAttribute('class','trail');
    trailsG.append(s.ghost,s.trail);
    s.lut=[];let m=-Infinity;for(let k=0;k<=80;k++){const tt=k/80;m=Math.max(m,bez(s,tt).y);s.lut.push([tt,m])}
    s.tg=clamp(SPIN_PX()/Math.max(1,s.a1-s.a0),.05,.45);
    segs.push(s);
  }
  render();
}

function render(){
  if(reduce||!segs.length)return;
  const first=segs[0].a0,last=segs[segs.length-1].a1;
  const focus=Math.min(first,innerHeight*.55);
  const y=clamp(scrollY+focus,first,last);
  let s=0;while(s<segs.length-1&&y>segs[s].a1)s++;
  const g=segs[s],TG=g.tg,t=clamp((y-g.a0)/(g.a1-g.a0||1),0,1);
  // stick poses: the holder spins a full turn with the ball in the pocket, then whips it
  const ang=players.map((p,i)=>{
    if(i<s)return POSE.rest;
    if(i>s)return POSE.ready;
    if(t<TG*.7)return POSE.ready-360*easeInOut(t/(TG*.7));
    if(t<TG)return lerp(POSE.ready,POSE.release,easeOut((t-TG*.7)/(TG*.3)));
    return lerp(POSE.release,POSE.rest,clamp((t-TG)/.25,0,1));
  });
  players.forEach((p,i)=>setAngle(p,ang[i]));
  // ball: rides in the pocket during the spin, then flies the arc to the next stick
  let b,ct=0;
  if(t<TG){b=pocketPos(players[s],ang[s])}
  else{
    const u=(t-TG)/(1-TG),yy=lerp(g.p0.y,g.p1.y,u),L=g.lut;let k=1;while(k<L.length-1&&L[k][1]<yy)k++;
    const [t0,y0]=L[k-1],[t1,y1]=L[k];ct=clamp(y1>y0?lerp(t0,t1,(yy-y0)/(y1-y0)):t1,0,1);b=bez(g,ct);
  }
  const spin=(scrollY*1.4)%360;
  ball.setAttribute('transform',`translate(${b.x.toFixed(1)} ${b.y.toFixed(1)}) rotate(${spin.toFixed(1)})`);
  segs.forEach((q,i)=>q.trail.setAttribute('d',i<s?fullD(q):i===s&&ct>0.001?splitD(q,ct):''));
}
let ticking=false;
addEventListener('scroll',()=>{if(!ticking){ticking=true;requestAnimationFrame(()=>{render();ticking=false})}},{passive:true});
let rz;addEventListener('resize',()=>{clearTimeout(rz);rz=setTimeout(layout,120)});
addEventListener('load',layout);
document.fonts&&document.fonts.ready.then(layout);
layout();


})();
